import { render, staticRenderFns } from "./StockWorkspace.vue?vue&type=template&id=5307ac9d&scoped=true"
import script from "./StockWorkspace.vue?vue&type=script&lang=js"
export * from "./StockWorkspace.vue?vue&type=script&lang=js"
import style0 from "./StockWorkspace.vue?vue&type=style&index=0&id=5307ac9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5307ac9d",
  null
  
)

export default component.exports